import { createContext, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const LiveContext = createContext({ products: null, fetchedAt: null, announcements: null, newAdditions: null, sale: null });

/** Fetches live prices/stock, the store's announcement bar, the New Additions collection and the running sale once per page load. */
export const LiveProvider = ({ children }) => {
  const [state, setState] = useState({ products: null, fetchedAt: null, announcements: null, newAdditions: null, sale: null });
  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${BACKEND}/api/catalog`)
      .then((res) => {
        if (!cancelled) {
          setState({ products: res.data.products, fetchedAt: res.data.fetched_at, announcements: res.data.announcements, newAdditions: res.data.new_additions, sale: res.data.sale });
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);
  return <LiveContext.Provider value={state}>{children}</LiveContext.Provider>;
};

export const useLiveMeta = () => useContext(LiveContext);

/** Merge live Shopify price / compare-at / availability into a static catalog product. */
export const useLiveProduct = (p) => {
  const { products } = useContext(LiveContext);
  return useMemo(() => {
    const live = products?.[p.handle];
    if (!live) return { ...p, available: true, live: false };
    const v = p.variant ? live.variants[String(p.variant)] : null;
    const src = v || live;
    return { ...p, price: src.price, compare: src.compare ?? p.compare, available: src.available, saleTitle: src.sale_title || null, live: true };
  }, [products, p]);
};
